<template>
  <button class="btn">
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button"
};
</script>

<style scoped>
.btn {
  background: #37474f;
  background: var(--color-tertiary);
  border-radius: 0.5rem;
  outline: 0;
  border: 0;
  padding: 0.5em 1.5em;
  font-family: inherit;
  color: inherit;
  font-size: inherit;
  cursor: pointer;
  box-shadow: 0 1rem 1.25rem rgba(33, 33, 33, 0.25);
}
.btn:hover {
  background: #1e88e5;
  background: var(--color-danger);
}
</style>